import { render, staticRenderFns } from "./NTSFeedbackPage.vue?vue&type=template&id=9d4945e6&scoped=true"
import script from "./NTSFeedbackPage.vue?vue&type=script&lang=js"
export * from "./NTSFeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./NTSFeedbackPage.vue?vue&type=style&index=0&id=9d4945e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4945e6",
  null
  
)

export default component.exports